import getSymbolFromCurrency from 'currency-symbol-map';

export const defaultCurrency = 'USD';

export const currencies = [
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTC',
  'BTN',
  'BWP',
  'BYR',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CUC',
  'CUP',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EGP',
  'ERN',
  'ETB',
  'EUR',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GGP',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'IMP',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JEP',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRO',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDG',
  'SEK',
  'SGD',
  'SHP',
  'SLL',
  'SOS',
  'SRD',
  'STD',
  'SVC',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VEF',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XAG',
  'XAU',
  'XCD',
  'XDR',
  'XOF',
  'XPD',
  'XPF',
  'XPT',
  'YER',
  'ZAR',
  'ZMK',
  'ZMW',
  'ZWL',
];

export const currenciesOptions = currencies.map(currency => ({ text: currency, value: currency }));

export const transactedCurrencies = [
  'CAD',
  'USD',
  'GBP',
  'EUR',
  'AUD',
  'BRL',
  'CHF',
  'DKK',
  'NOK',
  'NZD',
  'SEK',
  'MXN',
  'JPY',
  'HKD',
];

export const transactedCurrenciesOptions = transactedCurrencies.map(currency => ({ text: currency, value: currency }));

export const zeroDecimalCurrencies = [
  'BIF',
  'DJF',
  'JPY',
  'KRW',
  'PYG',
  'VND',
  'XAF',
  'XPF',
  'CLP',
  'GNF',
  'KMF',
  'MGA',
  'RWF',
  'VUV',
  'XOF',
];

export const isZeroDecimalCurrency = currencyCode => zeroDecimalCurrencies.includes(currencyCode);

export const formatAmount = (intl, value = 0, currencyCode, addCurrencyString = true) => {
  const number = Math.abs(value).toFixed(2);
  const formattedNumber = intl.formatNumber(number, {
    minimumFractionDigits: isZeroDecimalCurrency(currencyCode) ? 0 : 2,
    maximumFractionDigits: isZeroDecimalCurrency(currencyCode) ? 0 : 2,
  })

  const symbol = getSymbolFromCurrency(currencyCode);

  if (value < 0) {
    return `-${symbol}${formattedNumber} ${addCurrencyString ? currencyCode : ''}`;
  }
  return `${symbol}${formattedNumber} ${addCurrencyString ? currencyCode : ''}`;
};

export const formatAmountWithStrippedCurrencyToFloat = (value = 0, currencyCode = 'USD') => {
  // "12.34" to 12.34 and "12" to 12.00 (non-zero decimal currency)
  // "123" to 123 (zero decimal currency)
  const amountToFloat = parseFloat(
    new Intl.NumberFormat('en-US', {
      currency: currencyCode,
      minimumFractionDigits: isZeroDecimalCurrency(currencyCode) ? 0 : 2,
      maximumFractionDigits: isZeroDecimalCurrency(currencyCode) ? 0 : 2,
    }).format(value).replace(/[^\d.-]/g, ''),
  );

  return amountToFloat;
};

export const formatStrippedAmountToString = (value, currencyCode) => {
  // 12.34 to "12.34" and 12 to "12.00" (non-zero decimal currency)
  // 123 to "123" (zero decimal currency)
  if (!isZeroDecimalCurrency(currencyCode)) return value.toFixed(2).toString();
  return value.toString();
};

export const convertToDollars = (cents, currency) => {
  return zeroDecimalCurrencies.includes(currency) ? cents : cents / 100;
};
